import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import { i18n } from './locales'

document.documentElement.lang = i18n.global.locale.value

const app = createApp(App)
app.use(i18n)
app.mount('#app')
